"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Flag = _interopRequireDefault(require("./Flag"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ModuleEnablementContext = require("@insided/shared/services/ModuleEnablementContext");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "flagRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (event) {
      var target = event.target;

      if (_this.dropdownRef && !_this.dropdownRef.contains(target) && _this.flagRef && !_this.flagRef.contains(target)) {
        _this.setState({
          isOpen: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isEntityEnabled = this.props.isEntityEnabled;
      return (0, _preact.h)("li", {
        className: "main-navigation--profile-link qa-header-profile-link"
      }, (0, _preact.h)("div", {
        ref: function ref(_ref) {
          return _this2.flagRef = _ref;
        },
        onClick: function onClick(e) {
          return _this2.toggleDropdown(e);
        },
        role: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' && _this2.toggleDropdown(e);
        },
        "aria-haspopup": "true",
        "aria-expanded": this.state.isOpen
      }, (0, _preact.h)(_Flag.default, this.props)), this.state.isOpen && (0, _preact.h)("div", {
        ref: function ref(_ref2) {
          return _this2.dropdownRef = _ref2;
        },
        className: (0, _classnames.default)('dropdown', 'dropdown--profile', 'qa-header-profile-dropdown'),
        role: "menu"
      }, (0, _preact.h)("span", {
        className: "arrow is-hidden-S"
      }), isEntityEnabled('profile') && (0, _preact.h)("div", {
        className: (0, _classnames.default)('user', 'flag ')
      }, (0, _preact.h)("div", {
        className: "user_data flag__body"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/members/user-".concat(this.props.id)),
        className: "link--text qa-menu-username"
      }, (0, _preact.h)(_phrase.default, {
        p: "My profile"
      })))), (0, _preact.h)("ul", {
        className: "list--menu"
      }, isEntityEnabled('topic') && (0, _preact.h)("li", {
        className: "list__item qa-menu-user-topics"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search/activity/topics?userid=".concat(this.props.id))
      }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "Topic|Topics",
        count: {
          c: this.props.topicsCount
        }
      })), (0, _preact.h)("span", {
        className: "counter"
      }, this.props.topicsCount))), isEntityEnabled('replies') && (0, _preact.h)("li", {
        className: "list__item qa-menu-user-reactions"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search/activity/reactions?userid=".concat(this.props.id))
      }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "Reply|Replies",
        count: {
          c: this.props.repliesCount
        }
      })), (0, _preact.h)("span", {
        className: "counter"
      }, this.props.repliesCount))), isEntityEnabled('topic') && (0, _preact.h)("li", {
        className: "list__item qa-menu-user-solved"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search/activity/solved?userid=".concat(this.props.id))
      }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "Solved",
        count: {
          c: this.props.solvedCount
        }
      })), (0, _preact.h)("span", {
        className: "counter"
      }, this.props.solvedCount))), isEntityEnabled('favorite') && (0, _preact.h)("li", {
        className: "list__item qa-menu-favorites"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/favorite/overview")
      }, (0, _preact.h)(_phrase.default, {
        p: "header.profile.dropdown.subscriptions"
      }))), isEntityEnabled('privateMessage') ? (0, _preact.h)("li", {
        className: "list__item qa-menu-private-messages"
      }, (0, _preact.h)("a", {
        className: (0, _classnames.default)('link--text', 'messages', {
          'counter-alert': this.props.pmUnreadCount > 0
        }),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/inbox/overview")
      }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "Private messages"
      })), (0, _preact.h)("span", {
        className: "counter"
      }, this.props.pmUnreadCount ? "".concat(this.props.pmUnreadCount, " /") : null, this.props.pmTotalCount))) : null, isEntityEnabled('transcript') && (0, _preact.h)("li", {
        className: "list__item qa-menu-education-transcript"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/education/app/transcript")
      }, (0, _preact.h)(_phrase.default, {
        p: "hub.user.dropdown.education.transcript"
      }))), isEntityEnabled('profile') && (0, _preact.h)("li", {
        className: (0, _classnames.default)('list__item', 'list__item--border-top', 'qa-menu-settings')
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/profile")
      }, (0, _preact.h)(_phrase.default, {
        p: "Settings"
      }))), (0, _preact.h)("li", {
        className: "list__item qa-menu-logout"
      }, (0, _preact.h)("a", {
        className: "link--text",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/member/logout"),
        onClick: function onClick() {
          return sessionStorage.setItem('UserLoggedOut', 'true');
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "Logout"
      }))))));
    }
  }]);
  return Dropdown;
}(_preact.Component);

var _default = (0, _ModuleEnablementContext.withModuleEnablement)(Dropdown);

exports.default = _default;